import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "../reducer/userSlice";
import historyReducer from "../reducer/historySlice";
import globalDataReducer from "../reducer/globalDataSlice";

const rootReducer = combineReducers({
  user: userReducer,
  history: historyReducer,
  globalData: globalDataReducer, // <--- Usa la costante "globalDataReducer"
});

/**
 * Funzione di riconciliazione che valida lo stato salvato prima di ripristinarlo.
 * Previene il ripristino di stati "zombie" (loggato ma senza token valido).
 */
const reconcileState = (inboundState: any, originalState: any, reducedState: any, config: any) => {
  // Se non c'è stato salvato, usa lo stato iniziale
  if (!inboundState) {
    console.log('📦 Nessuno stato salvato - uso stato iniziale');
    return reducedState;
  }

  // Controlla se l'utente risulta loggato nello stato salvato
  if (inboundState.user && inboundState.user.isLoggedIn === true) {
    // Verifica se c'è un token valido
    // Nota: il token non è più salvato in Redux ma in sessionStorage via AuthService
    // Quindi se Redux dice "loggato" ma non c'è token in sessionStorage, lo stato è invalido
    const hasToken = sessionStorage.getItem('userToken') || sessionStorage.getItem('authToken');

    if (!hasToken) {
      console.log('🧹 Stato "loggato" senza token valido - pulizia stato Redux');
      // Ripristina SOLO history e globalData, resetta user allo stato iniziale
      return {
        ...reducedState,
        history: inboundState.history || reducedState.history,
        globalData: inboundState.globalData || reducedState.globalData,
      };
    } else {
      console.log('✅ Stato "loggato" con token valido - ripristino completo');
    }
  }

  // In tutti gli altri casi, ripristina lo stato salvato normalmente
  return inboundState;
};

const persistConfig = {
  key: "root",
  storage,
  stateReconciler: reconcileState, // Usa la nostra funzione di validazione
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
